// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSVImporter_FileStep__header {
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;
  font-size: 1.15em;
  color: #808080;
}
.CSVImporter_FileStep__headerToggle {
  display: flex;
  align-items: center;
  margin-top: -0.5em;
  margin-bottom: -0.5em;
  margin-left: 1.5em;
  color: #202020;
  cursor: pointer;
}
.CSVImporter_FileStep__headerToggle > input[type=checkbox] {
  margin-right: 0.5em;
  width: 1.2em;
  height: 1.2em;
  cursor: pointer;
}
.CSVImporter_FileStep__mainPendingBlock {
  display: flex;
  align-content: center;
  justify-content: center;
  padding: 2em;
  color: #808080;
}`, "",{"version":3,"sources":["webpack://./components/csv_import/file-step/FileStep.scss","webpack://./theme.scss"],"names":[],"mappings":"AAGE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBCKY;EDJZ,cCCiB;ADHrB;AAKE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cCTQ;EDUR,eAAA;AAHJ;AAKI;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AAHN;AAOE;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,cCxBiB;ADmBrB","sourcesContent":["@import '../../../theme.scss';\n\n.CSVImporter_FileStep {\n  &__header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.5em;\n    font-size: $titleFontSize;\n    color: $textSecondaryColor;\n  }\n\n  &__headerToggle {\n    display: flex;\n    align-items: center;\n    margin-top: -0.5em; // allow for larger toggle element\n    margin-bottom: -0.5em;\n    margin-left: 1.5em;\n    color: $textColor;\n    cursor: pointer;\n\n    > input[type='checkbox'] {\n      margin-right: 0.5em;\n      width: 1.2em;\n      height: 1.2em;\n      cursor: pointer;\n    }\n  }\n\n  &__mainPendingBlock {\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    padding: 2em;\n    color: $textSecondaryColor;\n  }\n}\n","$fgColor: #000;\n$fillColor: #f0f0f0;\n$controlBorderColor: #808080;\n$controlBgColor: #fff;\n\n$invertedTextColor: #f0f0f0;\n$invertedBgColor: #404040;\n\n$textColor: #202020;\n$textSecondaryColor: #808080;\n$textDisabledColor: rgba($textColor, 0.5);\n$errorTextColor: #c00000;\n$titleFontSize: 1.15em; // relative to body font\n\n$borderRadius: 0.4em;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
